import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import TripleSingleSelect from '../../TripleSingleSelect';
import QuestionTitle from './QuestionTitle';
import QuestionSubTitle from './QuestionSubTitle';
import QuestionOptionsContainer from './QuestionOptionsContainer';

import { setFieldValue } from '../actions';

const TripleQuestionDropdown = props => {
  const { question, setFieldValue, form } = props;
  const { id, title, subtitle, options } = question;

  const handleOptionSelectChange = valueObject => {
    const { name, values } = valueObject;
    setFieldValue({
      id: name,
      value: values
    });
  };

  const getValues = () => {
    const values = {};
    for (const option of options) {
      values[option.name] = form[option.name] || [];
    }
    return values;
  };

  return (
    <Grid key={id}>
      <QuestionTitle label={title} />

      {subtitle && <QuestionSubTitle label={subtitle} />}

      <QuestionOptionsContainer>
        <TripleSingleSelect options={options} values={getValues()} onChange={handleOptionSelectChange} />
      </QuestionOptionsContainer>
    </Grid>
  );
};

TripleQuestionDropdown.propTypes = {
  /**
   * Question object with title, subtitles, etc
   */
  question: PropTypes.object.isRequired,
  /**
   * Questionnaire form values
   */
  form: PropTypes.object,
  /**
   * Set the selected value of the question
   */
  setFieldValue: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  form: state?.questionnaire?.form
});

const mapDispatchToProps = dispatch => ({
  setFieldValue: payload => dispatch(setFieldValue(payload))
});

export default connect(mapStateToProps, mapDispatchToProps)(TripleQuestionDropdown);
